export const optimizedGetPlatform = () => {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator?.userAgentData?.platform;

    const os = {
        mac: /Macintosh|MacIntel|MacPPC|Mac68K|macOS/.test(platform),
        ios: /iPhone|iPad|iPod/.test(platform),
        windows: /Win32|Win64|Windows|WinCE/.test(platform),
        android: /Android/.test(userAgent),
        linux: /Linux/.test(platform),
    };

    for (const key in os) {
        if (os[key]) {
            return key;
        }
    }

    return null;
};

